// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

import site from '@/views/site/Site';

import agent from '@/views/agent/Agent';

import userinfo from '@/views/userinfo/Userinfo';

import order from '@/views/order/Order';

import gtye from '@/views/gtye/Gtye';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [ {
            path: '/site/Site',
            name: '位置管理',
            component: site,
            meta: {
                requireAuth: true
            }
        },  {
          path: '/agent/Agent',
          name: '站桶员管理',
          component: agent,
          meta: {
            requireAuth: true
          }
        },  {
          path: '/userinfo/Userinfo',
          name: '用户管理',
          component: userinfo,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/order/Order',
          name: '订单管理',
          component: order,
          meta: {
            requireAuth: true
          }
        },   {
          path: '/gtye/Gtye',
          name: '商品积分管理',
          component: gtye,
          meta: {
            requireAuth: true
          }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js